module.exports = __webpack_public_path__ + "img/ricelog_pinicon_020.c6612221.png";